import { Text, StackChildren, Colors } from '@doordash/design-language'
import AppDownloadButton, {
  AppDownloadOS,
} from '../../atoms/app-download-button'
import {
  isWebview,
  getMobileDevice,
  MobileDevice,
} from '../../../utilities/userAgent'
import { IOS_CLOSE_DEEPLINK, ANDROID_CLOSE_DEEPLINK } from '../../../constants'
import Button from '@doordash/component-button'
import * as React from 'react'
import completeDeliveryStepStrings from './strings'
import { goToDeepLink } from '../delivery-issues/utilities'

const CompleteDeliveryStep: React.FC = () => {
  const getOSType = () => {
    // TODO: @alexkim-doordash
    // Ideally getMobileDevice should just get us the device os, but due to string
    // shenanigans, it's not the enum that AppDownloadButton os prop is looking for.
    // When more time is available, I'll take a look to see if we can refactor the
    // two together.
    const deviceType = getMobileDevice()
    const isAndroid = deviceType === MobileDevice.Android
    return isAndroid ? AppDownloadOS.ANDROID : AppDownloadOS.IOS
  }

  const isMobile = isWebview()

  const completeDeliveryStepDescription = isMobile
    ? completeDeliveryStepStrings.progressionCheckCompleteFirstDeliveryAppDescription()
    : completeDeliveryStepStrings.progressionCheckCompleteFirstDeliveryMobileWebDescription()
  return (
    <StackChildren>
      <Text color={Colors.SystemGrey80}>{completeDeliveryStepDescription}</Text>
      {isMobile ? (
        <Button
          type={Button.Types.PrimaryPill}
          size={Button.Sizes.Small}
          onClick={() => {
            goToDeepLink({
              ios: IOS_CLOSE_DEEPLINK,
              android: ANDROID_CLOSE_DEEPLINK,
            })
          }}
          isInline
        >
          {completeDeliveryStepStrings.progressionCheckCompleteFirstDeliveryGetStarted()}
        </Button>
      ) : (
        <AppDownloadButton
          os={getOSType()}
          name={completeDeliveryStepStrings.progressionCheckCompleteFirstDeliveryDownloadApp()}
        />
      )}
    </StackChildren>
  )
}

export default CompleteDeliveryStep
